import { render, staticRenderFns } from "./HeatmapCalendar.demo.vue?vue&type=template&id=c9aff4de&scoped=true"
import script from "./HeatmapCalendar.demo.vue?vue&type=script&lang=js"
export * from "./HeatmapCalendar.demo.vue?vue&type=script&lang=js"
import style0 from "./HeatmapCalendar.demo.vue?vue&type=style&index=0&id=c9aff4de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9aff4de",
  null
  
)

export default component.exports